import { useEffect, useState } from 'react';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
// @ts-ignore
import InputLabel from '@mui/material/InputLabel';

export function RadioDropList({list, $selected = {}, onChangeStatus}){
    const [selected, setSelected] = useState({});
    const handleChange = (event) => {
        console.log("RDL", event.target.value)
        let temp = event.target.value.split('.')
        setSelected({id:temp[0], val: temp[1]})
    }

    useEffect(() => {
        setSelected($selected)
      }, [$selected]);

    console.log("list", list)
    console.log("selected", selected)



    return (
        <div style={{ display: "flex", flexDirection: 'row', justifyContent: "space-between", alignItems: "center", flexWrap: "wrap"}}>
            {list.map((item) => (
                <FormControl key={item.id} style={{ minWidth: "20%", }}>
                    <Select
                        // @ts-ignore
                        value={selected.id === item.id ? item.id + "." + selected.val : null}
                        onChange={handleChange}
                        displayEmpty
                        IconComponent={() => null}
                        renderValue={(selectedValue) => {
                            if (!selectedValue) {
                                return <span style={{ color: "#858585" }}>{item.groupname}</span>;
                            }
                            const el = item.list.find(
                                (el) => item.id + "." + el.status === selectedValue
                            );
                            return el ? el.name : "";
                        }}
                        sx={{
                            // @ts-ignore
                            backgroundColor: selected.id === item.id ? '#bedcde' : "#ffffff",
                            borderRadius: "10px",
                            fontSize: "15px",
                            marginRight: "2px",
                            height: "30px",
                            color: "#858585",
                            // Стили для границ
                            '& .MuiOutlinedInput-notchedOutline': {
                                borderColor: '#bedcdd',
                            },
                            '&:hover .MuiOutlinedInput-notchedOutline': {
                                borderColor: '#bedcdd',
                            },
                            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                borderColor: '#bedcdd',
                            },

                            '& .MuiSelect-select': {
                                paddingLeft: '6px !important',
                                paddingRight: '6px !important',
                                textAlign: 'center',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                color: "#858585",
                            },

                            '& .MuiSelect-icon': {
                                display: 'none !important',
                            }
                        }}
                    >
                        {item.list.map((el, i) => (
                            <MenuItem
                                key={i}
                                value={item.id + "." + el.status}
                                onClick={() => onChangeStatus(item.id, el.status)}
                                sx={{ color: "#858585" }}
                            >
                                {el.name}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            ))}
            
        </div>
    )
}